// Job Overview (A15) — the pure half of a job's first tab: which of its rows
// belong on it, and in what order. The reads and the DOM live in
// js/admin/31-job-overview.js. Nothing here writes or fetches.

import { localDateStr } from './period.js';
import { isPendingSlip } from './delivery-row.js';

// A delivery is open until it arrived, was received or was called off. A
// pickup is born 'delivered' (js/core/delivery-row.js), so it is never open;
// a packing slip waiting for the office (isPendingSlip) is not an order on
// its way either.
export const CLOSED_DELIVERY = ['delivered', 'confirmed_received', 'cancelled'];
// Extra work the office still has to act on: priced (submitted) or sent to the GC.
export const PENDING_EWO = ['submitted', 'sent'];
// Change orders not yet settled. A flagged SI with no co_status yet is a draft.
export const PENDING_CO = ['draft', 'sent'];

const str = v => String(v ?? '');

/**
 * rows: { subs, deliveries, ewos, cos, tasks } as fetched for ONE job.
 * today: 'YYYY-MM-DD' in the admin's own calendar.
 */
export function overviewModel(rows, today) {
  const { subs = [], deliveries = [], ewos = [], cos = [], tasks = [] } = rows || {};
  const forms = subs.slice().sort((a, b) => str(b.submitted_at).localeCompare(str(a.submitted_at)));
  const isToday = s => localDateStr(s.submitted_at) === today;
  return {
    formsToday: forms.filter(isToday),
    formsEarlier: forms.filter(s => !isToday(s)),
    // Soonest needed first; a request with no date goes last, not first.
    openDeliveries: deliveries.filter(d => !CLOSED_DELIVERY.includes(d.status) && !isPendingSlip(d))
      .sort((a, b) => (a.needed_by || '9999-12-31').localeCompare(b.needed_by || '9999-12-31')),
    pendingEwos: ewos.filter(e => PENDING_EWO.includes(e.status))
      .sort((a, b) => (Number(a.ewo_number) || 0) - (Number(b.ewo_number) || 0)),
    pendingCos: cos.filter(c => c.status === 'change_order' && PENDING_CO.includes(c.co_status || 'draft')),
    // Not finished yet, in the order they start; a running task leads.
    upcoming: tasks.filter(t => str(t.end_date) >= today)
      .sort((a, b) => str(a.start_date).localeCompare(str(b.start_date)) || str(a.title).localeCompare(str(b.title))),
  };
}
